import ReportCreationSuccessScreen from '@screens/ReportCreation/ReportCreationSuccessScreen';

export default ReportCreationSuccessScreen;
